`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('animation.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'buddha-educational-animation' }">{{ $t('animation.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card
          title="阿雄與悉達多"
          class="mb-3"
        >
          <b-button
            variant="primary"
            target="_blank"
            :to="{ name: 'series', params: { series_no: 'TI001360' } }"
          >點播或下載</b-button>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col md="6">
              <b-card-img 
                src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/000.jpg"
                alt="小真的六度波羅蜜"
                class="rounded-0"
              ></b-card-img>
            </b-col>
            <b-col md="6">
              <b-card-body title="小真的六度波羅蜜">
                <b-card-text style="color:red">本會誠意鉅獻！</b-card-text>
                <b-card-text>
                  由真實故事改編，介於現實與奇幻、真實與想像的奇妙空間，<br>
                  滿足大人和小孩幻想。<br>
                  本片全長 84 分鐘。
                </b-card-text>
                <b-card-text>
                  （本卡通動畫，全長 84 分鐘。欣賞影片後，邀請您填寫問卷，您寶貴的意見，將可讓基金會製作出更精采、啟發善心的佛教卡通。）
                  <a href="https://www2.budaedu.org/newGhosa/C015/TI000512/TI000512.doc">填寫問卷</a>
                </b-card-text>
                <b-button-toolbar>
                  <b-button-group>
                    <b-button
                      variant="outline-default"
                      @click="$bvModal.show('info')"
                    >簡介</b-button>
                    <b-button
                      variant="primary"
                      target="_blank"
                      :to="{ name: 'series', params: { series_no: 'TI000512' } }"
                    >點播或下載</b-button>
                  </b-button-group>
                </b-button-toolbar>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
        <b-modal id="info" title="小真的六度波羅蜜" size="lg" scrollable centered>
          <b-container fluid>
            <b-row class="mb-1">
              <b-col>
                <p>剛上國中的小真沒有前排牙齒，開學第一天就被同學嘲笑。小真的生活簡直一團糟，沒有媽媽，爸爸入獄，功課差，沒有朋友，在學校不敢和同學說話，回到家老是被阿嬤罵！而妹妹小美每次都考第一名，長的漂亮又被阿嬤寵愛，像小公主……為什麼人生這麼不公平？小真覺得自己好倒楣。</p>
                <p>終於有一天好運降臨，老師要小真參加全國繪畫比賽。「如果得到第一名，就有獎金可以裝假牙！我就能擺脫悲慘的命運！」小真的美夢被阿嬤阻止，要求她考試第一名才能參加比賽，這對小真來說難如登天。</p>
                <p>這時，山上德化寺的德師父給了小真一本《六度集經》，沒想到這本神奇的書卻改變了小真的人生…</p>
                <p>小真意外進入了書中的奇幻世界，遇見神龜、象王、毒蛇、蜜蜂王，展開了一段又一段奇異的書中旅程，她開始發現這個世界並不是她想的那樣…</p>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col><hr></b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-img fluid src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/001.jpg"></b-img>
              </b-col>
              <b-col>
                <b-img fluid src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/002.jpg"></b-img>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col><hr></b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-img fluid src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/003.jpg"></b-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-img fluid src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/004.jpg"></b-img>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-img fluid src="https://www2.budaedu.org/official-website-data/buddha-educational-animation/jane's-enlightenment-of-six-perfections/005.jpg"></b-img>
              </b-col>
            </b-row>
          </b-container>
          <template #modal-footer="{ close }">
            <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'buddha-educational-animation',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('animation.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>